<template>
  <!-- BEGIN pos-counter-content -->
  <div class="ts-p-6">
    <div class="ts-space-y-4">
      <label
        class="col-form-label ts-mb-3 ts-font-bold ts-w-full ts-px-2 bg-success ts-flex ts-justify-items-center ts-items-center"
        style="height: 45px;">
        <i class="fas fa-file-alt fa-fw fa-lg ts-pb-1" style="color: white;"></i>
        <h4 style="margin: 0 !important;color: white;" class="ts-pl-2">{{ $t('restaurantSale.invoiceList') }}</h4>
      </label>
      <div class="ts-grid ts-grid-cols-1 md:ts-grid-cols-3 ts-gap-2">
        <a-range-picker style="width:100%" v-model="date_range" valueFormat="DD-MM-YYYY HH:mm"
          :show-time="{ format: 'HH:mm' }" format="DD-MM-YYYY HH:mm" />
        <div></div>
        <input v-model.trim="search" ref="search" type="text" :placeholder="$t('restaurantSale.searchInovice')"
          class="form-control" />
      </div>
      <div class="ts-border-t ts-border-gray-300 ts-py-4">
        <a-tabs :activeKey="1">
          <a-tab-pane :key="1" tab="Recently">
            <div>
              <vue-custom-scrollbar class="pos-counter-content-container">
                <ts-loading-banner :loading="loading">
                  <div class="ts-grid ts-grid-cols-1 md:ts-grid-cols-3 ts-gap-2">
                    <InvoiceCard v-for="(invoice, index) in inviceLists" :invoice="invoice" :selected="false"
                      @cancel="$emit('cancel')" @reprint="handleReprint" />
                  </div>
                </ts-loading-banner>
              </vue-custom-scrollbar>
            </div>
            <!-- <InvoiceCard /> -->
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
    <div class="btn-row ts-space-x-2 ts-text-right ts-border-t ts-border-gray-300 ts-pt-4">
      <ts-button @click.prevent="$emit('cancel')"><i class="fa fa-arrow-left fa-fw fa-lg"></i>
        {{ $t('restaurantSale.back') }}</ts-button>
    </div>
    <Spin size="large" fix v-if="loading || waiting"></Spin>
  </div>
  <!-- END pos-counter-content -->
</template>

<script>
import { Errors } from 'form-backend-validation'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
import RecieptPreview from './reciept-preview'
import InvoiceCard from './invoice-card.vue'
import moment from 'moment'

export default {
  props: {
    loading: {
      type: Boolean,
      required: false
    },
  },
  name: 'invoiceList',
  components: {
    RecieptPreview,
    InvoiceCard
  },
  data() {
    return {
      errors: new Errors(),
      search: '',
      printing: false,
      model: {
        table_id: null,
        stock_out_id: null,
        linked_keys: [],
      },
      date_range: [
        moment().startOf('day').format('DD-MM-YYYY HH:mm'),
        moment().endOf('day').format('DD-MM-YYYY HH:mm')
      ],
      waiting: false,
      isScanning: false,
      activeKey: 1,
    }
  },
  created() { },
  computed: {
    inviceLists() {
      return this.$store.state.restaurantSale.counterCheckout.inviceLists.filter(
        ei =>
          this.search
            .split(' ')
            .every(s =>
              ei.invoice_no.toLowerCase().includes(s.toLowerCase())
            ) ||
          this.search
            .split(' ')
            .every(s =>
              ei.table_no.toLowerCase().includes(s.toLowerCase())
            )
      )
        .slice(0, 20)
    },
    inviceByTableLists() {
      return this.$store.state.restaurantSale.counterCheckout.inviceLists
    },
  },
  methods: {
    fetchInvoiceList(attributes) {
      this.waiting = true
      this.$store
        .dispatch(
          'restaurantSale/counterCheckout/fetchInvoiceList',
          { date_range: this.date_range }
        )
        .catch(error => {
          this.$notification['error']({
            message: 'FETCH MEMBER CARD',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => (this.waiting = false))
    },
    getProductByStatus(productList, status) {
      if (status == 1) {
        return productList.filter(el => el.end_time == null)
      }
      if (status == 2) {
        return productList.filter(el => el.end_time != null)
      }
      return productList
    },
    handleReprint(invoice) {
      // Add your reprint logic here
      this.waiting = true
      this.$store
        .dispatch('restaurantSale/counterCheckout/printBill', {
          stock_out_id: invoice.stock_out_id,
          counter_id: localStorage.getItem('counterId'),
          action_type: 'check-bill'
        })
        .then(() => { })
        .catch(error => {
          this.$notification['error']({
            message: 'Print Bill',
            description: error.messages,
            placement: 'bottomRight'
          })
        })
        .finally(() => {
          this.waiting = false
        })

      // Example: Show success message
      // this.$notification.success({
      //   message: 'Reprint',
      //   description: `Invoice ${invoice.invoice_no} sent to printer`,
      //   duration: 3
      // });
    }
  },
  watch: {
    date_range: function (val) {
      if (val) {
        this.fetchInvoiceList()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.pos-counter {
  padding-top: 0;
  height: 400px !important;

  @media (max-width: 75em) {
    height: 400px !important;
  }

  @media (max-width: 54em) {
    height: 400px !important;
  }

  @media (max-width: 37.5em) {
    height: 350px !important;
  }
}

@media (max-width: 991.98px) {

  .pos-counter .pos-counter-header .logo,
  .time,
  .nav .nav-item {
    display: none;
  }

}
</style>
<style>
.ant-notification {
  z-index: 1030;
}
</style>